import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './alert.module.scss';

interface IAlertProps {
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
  autoHideDuration?: number;
}

export const Alert: React.FC<IAlertProps> = ({
  type,
  message,
  onClose,
  autoHideDuration = 3000,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  useEffect(() => {
    if (autoHideDuration <= 0) return;

    const timer = setTimeout(() => {
      setIsClosing(true);
      setTimeout(onClose, 300);
    }, autoHideDuration);

    return () => clearTimeout(timer);
  }, [autoHideDuration, onClose]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 300);
  };

  const typeClass = type === 'success' ? styles.success : styles.error;

  return ReactDOM.createPortal(
    <div
      className={`${styles.alert} ${typeClass} ${
        isVisible && !isClosing ? styles.alert_visible : styles.alert_hidden
      }`}
    >
      <span className={styles.alert__message}>{message}</span>
      <button className={styles.alert__close} onClick={handleClose}>
        &#x2715;
      </button>
    </div>,
    document.body
  );
};
